
<div class="cmp-sidebar-layout-item">
  <slot></slot>
</div>
